import styled from "styled-components";

// Accepts a `dataTest` prop so call sites rendering these in a list can give
// each card a stable, unique handle for tests.
export const MembershipCard = styled.div.attrs(({ dataTest }) => ({
  "data-test": dataTest,
}))`
  display: flex;
  flex-direction: column;
  gap: 12px;
  border: 1px solid #dddbda;
  border-radius: 5px;
  padding: 6px;
  padding-bottom: 8px;

  ${(props) =>
    props.status === "success" &&
    `
    border-color: var(--success);
  `}

  ${(props) =>
    props.status === "error" &&
    `
    border-color: var(--error);
  `}
`;

export const MembershipCardError = styled.div`
  font-family: "Inter";
  color: var(--error);
  font-size: 12px;
  text-align: left;
  padding: 2px;
  min-height: 22px;
  line-height: 14px;
`;
